<!-- TODO - this is a simplified Modal file for use in the dashboard without
some additional features that the Modal for ai-campaigns uses. We wish to
merge/refactor these into one file later, these are only separate
for development purposes -->
<style lang="scss">
  button {
    border: 0;
    cursor: auto;
  }
  #swModalDiv {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background: white;
    border-radius: 1rem;
    padding: 0rem;
    animation: zoom 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  #modalBackdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 998;
    display: block;
    animation: fade 0.2s ease-out;
  }
  #modalContents {
    text-align: center;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    overflow: visible;
    overscroll-behavior: contain;
    #modalClose {
      z-index: 10;
      background: white;
      border: 0;
      cursor: pointer;
      padding: 0.4rem 0rem 0rem 1rem;
      &:focus {
        outline: none;
      }
    }
  }

  @keyframes zoom {
    from {
      transform: translate(-50%, -50%) scale(0.95);
    }
    to {
      transform: translate(-50%, -50%) scale(1);
    }
  }

  @keyframes fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  button {
    display: block;
  }
</style>

<script>
  import { onDestroy, setContext } from "svelte";
  import { writable } from "svelte/store";
  import { isDialogModalOpen } from "../utils/stores";

  export let minModalWidth = null;
  export let modalWidth = null;
  export let selectedPanel;
  export let showModal;
  export let dialog;
  export let hideCloseButton = true;
  export let maxModalHeight = "50rem";

  export let additionalModalContentsStyle = ""; // TODO tidy up the styling here between various modals

  let modalContentsStyle = `max-height:${maxModalHeight}`;
  if (additionalModalContentsStyle) {
    modalContentsStyle = `${modalContentsStyle}; ${additionalModalContentsStyle}`;
  }

  const showDashboardModal = writable(showModal);
  setContext("showDashboardModal", showDashboardModal);
  $: showModal = $showDashboardModal;

  const closeModal = () => {
    showModal = false;
    document.body.style.overflow = "";
  };

  const handleEscKey = (event) => {
    if (event.key === "Escape" && showModal && !$isDialogModalOpen) {
      event.stopPropagation();
      closeModal();
    }
  };

  $: if (showModal) document.body.style.overflow = "hidden";

  onDestroy(() => {
    closeModal();
  });
</script>

<svelte:window on:keydown={handleEscKey} />

<div
  id="swModalDiv"
  class:sw-confirm-recipient-change={selectedPanel}
  bind:this={dialog}
  style={`${minModalWidth ? `min-width: ${minModalWidth};` : ""} ${modalWidth ? `width: ${modalWidth};` : ""}`}
>
  <div id="modalContents" style={modalContentsStyle}>
    {#if !hideCloseButton}
      <button id="modalClose" on:click={closeModal} aria-label="Close modal">
        <i class="fas fa-times"></i>
      </button>
    {/if}
    <slot />
  </div>
</div>
{#if showModal}
  <button id="modalBackdrop" on:click={closeModal} aria-label="Close modal"
  ></button>
{/if}
